import { render, staticRenderFns } from "./LvInfoOptionItem.vue?vue&type=template&id=0bc633f8&"
import script from "./LvInfoOptionItem.vue?vue&type=script&lang=js&"
export * from "./LvInfoOptionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports